/* Types */
import type {
  MetricDefinition,
  Service,
  ParamsPageView,
  ParamsDefault,
  ParamsEcommerce,
} from '@/services/metrics/types/service.types'

/*
 * Засчет Single Tone организуем единое объявление сервиса
 */
export default class ServiceMetrics implements Service {
  static instanceService: ServiceMetrics
  listMetrics: MetricDefinition[] = []

  constructor(...args: MetricDefinition[]) {
    if (ServiceMetrics.instanceService) return ServiceMetrics.instanceService

    this.#addMetrics(args)

    ServiceMetrics.instanceService = this

    this.#initVendor()
  }

  #addMetrics(args: MetricDefinition[]) {
    args.forEach((metric: MetricDefinition) => {
      if (!metric.ids.cityId && !metric.ids.mainId) return

      this.listMetrics.push(metric)
    })
  }

  #initVendor() {
    for (const metrics of this.listMetrics) {
      metrics.initVendor()
    }
  }

  eventSendGoal(args: ParamsDefault) {
    for (const metrics of this.listMetrics) {
      metrics.eventSendGoal(args)
    }
  }

  eventPageView(args: ParamsPageView) {
    for (const metrics of this.listMetrics) {
      metrics.eventPageView(args)
    }
  }

  /*
   * Методы отправки ecommerce
   */
  eventViewedProduct(args: ParamsEcommerce) {
    for (const metrics of this.listMetrics) {
      if (!metrics.ecommerce) return

      metrics.eventViewedProduct(args)
    }
  }

  eventAddProduct(args: ParamsEcommerce) {
    for (const metrics of this.listMetrics) {
      if (!metrics.ecommerce) return

      metrics.eventViewedProduct(args)
    }
  }

  eventPurchase(args: ParamsEcommerce) {
    for (const metrics of this.listMetrics) {
      if (!metrics.ecommerce) return

      metrics.eventPurchase(args)
    }
  }
}
